import HorizontalStepper from "../../components/website-flow/stepper/Stepper";
import PricingPlans from "../../components/website-flow/pricing-plans/PricingPlans";
import useWindowSize from "../../hooks/useWindowSize";
import { useCallback, useEffect, useState } from "react";
import { Typography, useTheme } from "@mui/material";
import React from "react";
import UserInformation from "../../components/website-flow/user-information/UserInformation";
import ThemeSection from "../../components/website-flow/theme-section/ThemeSection";
import SectionForm from "../../components/website-flow/section-form/SectionForm";
import DomainForm from "../../components/website-flow/domain-form/DomainForm";
import Domain from "../../components/website-flow/domain-search/DomainSearch";
// import DomainConnection from "../../components/website-flow/domain-connection/DomainConnection";
import Checkout from "../../components/website-flow/checkout/Checkout";
import PaymentForm from "../../components/website-flow/payment-form/PaymentForm";
import SuccessScreen from "../../components/website-flow/final-screen/FinalScreen";
import { get, patch, post, remove } from "../../services/apiService";
import Grid from "@mui/material/Grid2";
import BackdropLoader from "../../components/common/BackdropLoader";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import {
  getOneYearFromToday,
  parseXmlString,
  xmlToJson,
} from "../../utils/utils";
import { toast } from "react-toastify";
import { useAuth } from "../../hooks/useAuth";
import i18next from "i18next";

const WebsiteFlow = () => {
  const userId = sessionStorage.getItem("userId");
  const [activeStepNumber, setActiveStepNumber] = useState(null);
  const [activeStep, setActiveStep] = useState("");
  const [showSelectPlanButton, setShowSelectPlanButton] = useState(false);
  const [showPlansListing, setShowPlansListing] = useState(false);
  const [userDomainInfo, setUserDomainInfo] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [searchParams] = useSearchParams();
  const [isOpenPaymentDialogue, setOpenPaymentDialogue] = useState(false);
  const domainNameValue = searchParams.get("domainName");
  const [paymentResponse, setPaymentResponse] = useState(null);
  const { currentLang } = useAuth();

  const [showDomain, setShowDomain] = useState({
    domainForm: false,
    domainSelection: false,
    domainRegistration: false,
  });
  const [showPayment, setShowPayment] = useState({
    paymentCheckout: false,
    paymentForm: false,
  });

  const { width } = useWindowSize();
  const theme = useTheme();
  const steps = [
    "ONBOARD_WEBSITE_FLOW_SELECT_PLAN",
    "ONBOARD_WEBSITE_FLOW_USER_INFORMATION",
    "ONBOARD_WEBSITE_FLOW_THEME_SELECTION",
    "SELECTIONS_TEXT",
    "ONBOARD_WEBSITE_FLOW_DOMAIN_SELECTION",
    "ONBOARD_WEBSITE_FLOW_PAYMENT",
    "ONBOARD_WEBSITE_FLOW_YOU_ARE_ALL_SET",
  ];
  const [subscriptionDurationValue, setSubscriptionValue] = useState(null);
  const [userSelectedPlan, setUserSelectedPlan] = useState(null);
  const navigate = useNavigate();
  // subTotal is used in Checkout component props but not directly in this component
  // eslint-disable-next-line no-unused-vars
  const [subTotal, setSubTotal] = useState(null);
  const [domainPrice, setDomainPrice] = useState(null);
  const [domainExpiryDate, setDomainExpiryDate] = useState(null);
  const [domainName, setDomainName] = useState("");
  const [totalAmount, setTotalAmount] = useState(null);
  const [planPricePerMonth, setPlanPricePerMonth] = useState(null);
  const [vat, setVat] = useState(12);
  const [planPrice, setPlanPrice] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(true);

  const [isPendingTransaction, setIsPendingTransaction] = useState(false);

  const onSecreenLoader = (isLoading) => {
    setIsScreenLoading(isLoading);
  };
  const onBackdropLoader = (isLoading) => {
    setIsLoading(isLoading);
  };

  const handleTheme = async (theme) => {
    const themeObject = {
      themeId: theme.id,
      themeName: theme.label,
      primaryColor: theme.color,
      primaryContrastColor: "#ffffff",
    };
    const response = await patch(
      `users/configure/theme/${userId}`,
      themeObject,
      {},
      onBackdropLoader
    );
    if (response.status === 200) {
      sessionStorage.setItem("themeId", response.data.id);

      setActiveStepNumber(3);
    }
  };

  const updateSections = async (sections) => {
    console.log('sections-------------->', sections);
    const apiSections = sections.map((section) => {
      return {
        sectionId: section?.id,
        sectionName: section.name,
        translation: section.translation
      };
    });
    console.log('api sections-------------->', apiSections);

    const hasInvalidSection = apiSections.some(
      (s) => !s.sectionId || !s.sectionName?.trim()
    );

    if (hasInvalidSection) {
      toast.error(i18next.t("Please enter section name before proceeding."));
      return;
    }

    const sectionObject = {
      themeId: userInfo?.theme?.id,
      sections: apiSections,
    };

    const response = await patch(
      `users/configure/sections/${userId}`,
      sectionObject,
      {
        headers: {
          "Accept-Language": currentLang
        }
      },
      onBackdropLoader
    );
    if (response?.status === 200) {
      setActiveStepNumber(4);
      setShowDomain({ ...showDomain, domainForm: true });
    }
  };

  const savePlan = async (planObject) => {
    const response = await patch(
      `users/configure/plan/${userId}`,
      planObject,
      {},
      onBackdropLoader
    );
    if (response.status === 200) {
      setActiveStepNumber(1);
    }
  };

  const saveDomain = async (domainObject) => {
    console.log('save domain is being called--------', domainObject);
    if (domainObject.isMicroband && domainObject.domainName.length === 0) {
      toast.error("Domain Cannot be empty");
    }
    else if (!domainObject.isMicroband && domainObject.domainStatus === 'personal') {
      toast.error("Domain Cannot be empty");
    }
    else {
      const response = await patch(
        `users/configure/domain/${userId}`,
        domainObject,
        {},
        onBackdropLoader
      );
      console.log('domain object------------->', domainObject);
      if (response?.status === 200) {
        setShowDomain({
          domainForm: false,
          domainSelection: false,
          domainRegistration: false,
        });

        setActiveStepNumber(5);
        setShowPayment({ ...showPayment, paymentCheckout: true });
      }
    }
  };

  const registerDomain = async () => {
    const domainObject = {
      DomainName: userInfo?.domain?.domainName || "",
      Years: "1",
      RegistrantFirstName: userInfo.fullName.split(" ")[0] || "",
      RegistrantLastName:
        userInfo.fullName.split(" ")[1] || userInfo.fullName.split(" ")[0],
      RegistrantAddress1: userInfo.address || "",
      RegistrantCity: userInfo.city || "",
      RegistrantStateProvince: userInfo.stateProvince || "",
      RegistrantPostalCode: userInfo.postalCode?.toString() || "",
      RegistrantCountry: userInfo.country || "",
      RegistrantPhone:
        userInfo.phoneNumber?.replace(/(\+\d{2})(\d+)/, "$1.$2") || "",
      RegistrantEmailAddress: userInfo.email || "",
      TechFirstName: userInfo.fullName.split(" ")[0] || "",
      TechLastName:
        userInfo.fullName.split(" ")[1] || userInfo.fullName.split(" ")[0],
      TechAddress1: userInfo.address || "",
      TechPostalCode: userInfo.postalCode?.toString() || "",
      TechCountry: userInfo.country || "",
      TechCity: userInfo.city || "",
      TechPhone: userInfo.phoneNumber?.replace(/(\+\d{2})(\d+)/, "$1.$2") || "",
      TechStateProvince: userInfo.stateProvince || "",
      TechEmailAddress: userInfo.email || "",
      AdminFirstName: userInfo.fullName.split(" ")[0] || "",
      AdminLastName:
        userInfo.fullName.split(" ")[1] || userInfo.fullName.split(" ")[0],
      AdminAddress1: userInfo.address || "",
      AdminCity: userInfo.city || "",
      AdminStateProvince: userInfo.stateProvince || "",
      AdminPostalCode: userInfo.postalCode?.toString() || "",
      AdminCountry: userInfo.country || "",
      AdminPhone: userInfo.phoneNumber?.replace(/(\+\d{2})(\d+)/, "$1.$2") || "",
      AdminEmailAddress: userInfo.email || "",
      AuxBillingFirstName: userInfo.fullName.split(" ")[0] || "",
      AuxBillingLastName:
        userInfo.fullName.split(" ")[1] || userInfo.fullName.split(" ")[0],
      AuxBillingAddress1: userInfo.address || "",
      AuxBillingCity: userInfo.city || "",
      AuxBillingStateProvince: userInfo.stateProvince || "",
      AuxBillingPostalCode: userInfo.postalCode?.toString() || "",
      AuxBillingCountry: userInfo.country || "",
      AuxBillingPhone:
        userInfo.phoneNumber?.replace(/(\+\d{2})(\d+)/, "$1.$2") || "",
    };

    const response = await post(
      "users/domain/register",
      domainObject,
      {},
      onLoading
    );
    const xml = response.data;
    const xmlDoc = parseXmlString(xml);
    const object = xmlToJson(xmlDoc);
    const status = object.ApiResponse["@attributes"].Status;
    if (status === "OK") {
      setIsLoading(false);
      const isRegistered =
        object.ApiResponse.CommandResponse.DomainCreateResult["@attributes"]
          ?.Registered;
      if (isRegistered === "true") {
        await updateDomainStatus("registered", userInfo?.domain?.domainName);
        toast.success("Domain Registered Successfully");
      }
    } else {
      setIsLoading(false);
      await updateDomainStatus("failed", userInfo?.domain?.domainName);
      toast.error(object.ApiResponse.Errors.Error["#text"]);
    }
  };

  const onLoading = () => { };

  const updateDomainStatus = async (domainStatus, domainName) => {
    const domainStatusUpdateRes = await patch(
      `users/domain/update-status/${userId}`,
      { domainName: domainName, domainStatus: domainStatus },
      {},
      onLoading
    );
    return domainStatusUpdateRes;
  };

  const updatePlan = async (planObject, isStay) => {
    const response = await patch(
      `users/configure/plan/${userId}`,
      planObject,
      {},
      onBackdropLoader
    );

    if (response.status === 200) {
      setShowPlansListing(false);
      if (isStay) {
        await fetchUserPlan();
        setShowPayment({
          ...showPayment,
          paymentCheckout: true,
          paymentForm: false,
        });
      } else {
        setShowPayment({
          ...showPayment,
          paymentCheckout: false,
          paymentForm: true,
        });
      }
    }
  };

  const deletePlan = async (planId) => {
    const response = await remove(
      `users/${userId}/plan/${planId}/delete`,
      {},
      onBackdropLoader
    );
    if (response.status === 200) {
      setShowSelectPlanButton(true);
      await fetchUserPlan();
    }
  };

  const fetchUserPlan = useCallback(async () => {
    try {
      setIsScreenLoading(true);
      const response = await get(`users/${userId}/plan`, {
        headers: {
          "Accept-Language": currentLang
        }
      }, onSecreenLoader);
      if (response.status === 200) {
        if (!response.data) {
          setShowSelectPlanButton(true);
          setUserSelectedPlan(null);
          setSubTotal(null);
          setSubscriptionValue(null);
        } else {
          setShowSelectPlanButton(false);
          setUserSelectedPlan(response.data);
        }
      } else {
        console.warn("Unexpected status code:", response.status);
      }
    } catch (error) {
      setShowSelectPlanButton(true);
      setUserSelectedPlan(null);
      setSubTotal(null);
      setSubscriptionValue(null);
    }
  }, [userId, currentLang]);

  useEffect(() => {
    if (activeStepNumber === 5) {
      fetchUserPlan();
    }
  }, [activeStepNumber, fetchUserPlan, currentLang]);

  const changeURL = useCallback(() => {
    if (window.location.pathname === '/success-payment') {
      navigate("/website-flow");
    }
  }, [navigate]);

  const updateStep = useCallback((step) => {
    if (step === "plan") {
      setActiveStepNumber(0);
      changeURL();
    } else if (step === "information") {
      setActiveStepNumber(1);
    } else if (step === "theme") {
      setActiveStepNumber(2);
      changeURL();
    } else if (step === "section") {
      setActiveStepNumber(3);
      changeURL();
    } else if (step === "domain") {
      setShowDomain((prev) => ({ ...prev, domainForm: true }));
      setActiveStepNumber(4);
      changeURL();
    } else if (step === "payment") {
      setActiveStepNumber(5);
      setShowPayment((prev) => ({ ...prev, paymentCheckout: true }));
      changeURL();
    } else if (step === "complete") {
      setActiveStepNumber(6);
      navigate("/success-payment");
    } else {
      setActiveStepNumber(0);
    }
  }, [changeURL, navigate]);

  useEffect(() => {
    const fetchUserStep = async () => {
      try {
        if (userId) {
          const response = await get(`users/${userId}`, {}, onFetchUserStep);
          const userInfo = response.data;
          setUserInfo(userInfo);
          const step = response?.data?.step;
          updateStep(step);
          setActiveStep(step);
        }
      } catch (error) {
        const step = "plan";
        setActiveStepNumber(step === "plan" ? 0 : 0);
      }
    };

    fetchUserStep();
  }, [userId, updateStep]);

  useEffect(() => {
    if (userSelectedPlan) {
      setSubTotal(userSelectedPlan?.subTotal);
      setPlanPrice(userSelectedPlan.subTotal);
      userSelectedPlan?.vat && setVat(Number(userSelectedPlan?.vat));
      setUserDomainInfo(userSelectedPlan?.userDomain);
      setDomainPrice(
        userSelectedPlan?.userDomain?.price
          ? userSelectedPlan?.userDomain?.price
          : 0
      );
      setDomainExpiryDate(userSelectedPlan?.userDomain?.expiryDate);
      setDomainName(userSelectedPlan?.userDomain?.domainName || "");
      setTotalAmount(userSelectedPlan.total);
      setPlanPricePerMonth(
        userSelectedPlan.subTotal / userSelectedPlan?.subscriptionDuration
      );
      setSubscriptionValue(userSelectedPlan?.subscriptionDuration);
    }
  }, [userSelectedPlan]);

  const handleStepChange = (currentStep, index) => {
    if (!activeStep.trim().includes("complete") && currentStep !== 6) {
      if (currentStep === 4) {
        setShowDomain((prev) => ({ ...prev, domainForm: true }));
      }
      setActiveStepNumber(currentStep);
    }
  };

  const setHostForDomain = async () => {
    const hostObject = {
      Name: userInfo.domain.domainName
    };
    if (!userInfo.domain.isMicroband) {
      hostObject.DomainName = userInfo.domain.domainName;
    }

    const setHostResponse = await patch(
      `users/domain/host`,
      hostObject,
      {},
      onLoading
    );
    handleApiResponse(setHostResponse);
  };

  function handleApiResponse(response) {
    const xmlString = response.data;

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    const errorNode = xmlDoc.getElementsByTagName("Error")[0];
    const successAttr = xmlDoc.querySelector("DomainDNSSetHostsResult")?.getAttribute("IsSuccess");

    if (errorNode) {
      const errorMsg = errorNode.textContent || "An unknown error occurred";
      toast.error(`${errorMsg}`);
    } else if (successAttr === "true") {
      toast.success("Domain DNS has been set successfully!");
    } else {
      toast.error("Operation failed. Unknown issue.");
    }
  }

  const handleDomainFlow = async (domainStatus) => {
    if (domainStatus === "purchase") {
      await registerDomain();
    } else if (domainStatus === "personal") {
      await updateDomainStatus("registered", domainName);
    }
    await setHostForDomain();
  };

  const onFetchUserStep = () => { };

  return (
    <>
      <Grid container>
        <Grid
          item
          size={{ xl: 12, lg: 12, xs: 12 }}
          sx={{
            paddingLeft:
              width > 1500
                ? "17%"
                : width > 800
                  ? "10%"
                  : width > 650
                    ? "6%"
                    : "2%",
            paddingRight:
              width > 1500
                ? "17%"
                : width > 800
                  ? "10%"
                  : width > 650
                    ? "6%"
                    : "2%",
            marginTop: "5%",
            marginBottom: "5%",
          }}
        >
          <HorizontalStepper
            steps={steps}
            activeStepNumber={activeStepNumber}
            screenWidth={width}
            onStepClick={handleStepChange}
          />
        </Grid>
      </Grid>
      {isLoading && <BackdropLoader />}

      {(activeStepNumber === 0 || showPlansListing) && (
        <>
          <PricingPlans
            screenWidth={width}
            id="pricing"
            theme={theme}
            showPlansListing={showPlansListing}
            onSelect={(planObject) => {
              if (showPlansListing) {
                updatePlan(planObject, true);
              } else {
                savePlan(planObject);
              }
            }}
            showText={false}
          />
        </>
      )}
      {activeStepNumber === 1 && (
        <UserInformation
          onUserContinue={() => {
            setActiveStepNumber(2);
          }}
          screenWidth={width}
          userInfo={userInfo}
        />
      )}
      {activeStepNumber === 2 && (
        <ThemeSection
          screenWidth={width}
          onThemeContinue={(theme) => handleTheme(theme)}
        />
      )}
      {activeStepNumber === 3 && (
        <SectionForm
          screenWidth={width}
          onSectionContinue={(sections, themeId) => {
            updateSections(sections, themeId);
          }}
        />
      )}
      {activeStepNumber === 4 && showDomain.domainForm && (
        <DomainForm
          screenWidth={width}
          onDomainContinue={(domainIndex, domainObject) => {
            if (domainIndex === 0) {
              sessionStorage.setItem("isMicroband", false);
              setShowDomain({
                ...showDomain,
                domainSelection: true,
                domainForm: false,
              });
            } else {
              sessionStorage.setItem(
                "isMicroband",
                domainIndex === 1 ? true : false
              );
              saveDomain(domainObject);
            }
          }}
        />
      )}
      {activeStepNumber === 4 && showDomain.domainSelection && (
        <Domain
          screenWidth={width}
          onRegisterDomain={(domainObject) => {
            const themeId = sessionStorage.getItem("themeId") || "1";
            const domainPayload = {
              domainName: domainObject.domain,
              isMicroband: false,
              expiryDate: getOneYearFromToday(1),
              price:
                Number(domainObject.originalPrice) +
                Number(domainObject.additionalCost),
              domainStatus: "purchase",
              themeId: Number(themeId),
            };
            saveDomain(domainPayload);
          }}
        />
      )}

      {isPendingTransaction && (
        <Typography>
          Your Transaction is in progress. Kindly wait for it to avoid double
          payment
        </Typography>
      )}
      {activeStepNumber === 5 && showPayment.paymentCheckout && (
        <Checkout
          userDomainValue={domainNameValue}
          userSelectedPlan={userSelectedPlan}
          domainInfo={userDomainInfo}
          subscriptionDurationValue={subscriptionDurationValue}
          planPricing={planPrice}
          subTotal={(planPrice + domainPrice).toFixed(2)}
          total={totalAmount}
          userInfo={userInfo}
          domainName={domainName}
          vat={vat}
          domainExpiryDate={domainExpiryDate}
          actualAmount={planPricePerMonth}
          domainPrice={domainPrice}
          onReadyPay={(planObject) => updatePlan(planObject, false)}
          onDeletePlan={(planId) => deletePlan(planId)}
          onPendingTransaction={(isPending) =>
            setIsPendingTransaction(isPending)
          }
          onSuccessfullPayment={(isShowPaymentModal, paymentResponse) => {
            setActiveStepNumber(6);
            navigate("/success-payment");
            const domainStatus = userInfo.domain.domainStatus;
            handleDomainFlow(domainStatus);
            setOpenPaymentDialogue(isShowPaymentModal);
            setPaymentResponse(paymentResponse);
          }}
          onSelectPlan={() => {
            setShowPlansListing(true);
            setShowSelectPlanButton(false);
          }}
          showPlansListing={showPlansListing}
          onUpdateSubscriptionVaue={(value) => setSubscriptionValue(value)}
          onUpdateSubTotal={(subTotal) => {
            setSubTotal(subTotal);
          }}
          onUpdatePlanPricing={(planPrice) => {
            setPlanPrice(planPrice);
          }}
          onUpdateDomainPrice={(domainPrice) => {
            setDomainPrice(domainPrice);
          }}
          showSelectPlanButton={showSelectPlanButton}
          isLoading={isScreenLoading}
        />
      )}

      {activeStepNumber === 5 && showPayment.paymentForm && (
        <PaymentForm onPayNow={() => setActiveStepNumber(6)} />
      )}

      {activeStepNumber === 6 && (
        <SuccessScreen
          showPaymentModal={isOpenPaymentDialogue}
          onClosePaymentModal={() => {
            setOpenPaymentDialogue(false);
          }}
          paymentResponse={paymentResponse}
        />
      )}
    </>
  );
};

export default WebsiteFlow;